import { routesGuest } from '../../consts'

export const GUEST_MENU_INFO_LINKS = [
  { label: 'О проекте', path: routesGuest.ABOUT.path },
] as const

export const GUEST_HEADER_LEGAL_LINKS = [
  { label: 'Правила сообщества', path: routesGuest.RULES.path },
  { label: 'Конфиденциальность', path: routesGuest.PRIVACY.path },
  { label: 'Cookie', path: routesGuest.COOKIES.path },
] as const

export const GUEST_HEADER_MENU_LINKS = [
  ...GUEST_MENU_INFO_LINKS,
  ...GUEST_HEADER_LEGAL_LINKS,
] as const
